// This file is automatically generated. Do not edit manually.

import { t } from "i18next";

export const PartRevisionStateValues = ["INITIAL", "DESIGNED", "RELEASED"] as const;

export type PartRevisionState = (typeof PartRevisionStateValues)[number];

export const getPartRevisionStateLabels = () => ({
	INITIAL: t("initial"),
	DESIGNED: t("designed"),
	RELEASED: t("released"),
});

export const getPartRevisionStateLabel = (value: PartRevisionState): string => {
	return getPartRevisionStateLabels()[value];
};
